export type EventqSelectMenuPlacement = 'bottom-start' | 'bottom-end' | 'top-start' | 'top-end';

export type EventqSelectMenuWidth = 'trigger' | 'content';

export interface EventqSelectOption {
  readonly id: string;
  readonly label: string;
  /** Optional leading icon (absolute asset path) for menu rows. */
  readonly iconSrc?: string;
  /** Optional CSS color for the option label (and icon filter tint when needed). */
  readonly color?: string;
}

/** Priority-banded menu section (e.g. Escalation activity picker). */
export interface EventqSelectOptionGroup {
  readonly id: string;
  /** CSS background for the band (token preferred). */
  readonly background: string;
  readonly options: readonly EventqSelectOption[];
}

export interface EventqSelectMenuStyle {
  readonly top: string;
  readonly bottom: string;
  readonly left: string;
  readonly width: string;
}

/** Fixed menu box aligned to a trigger, for body-portaled menus. */
export function computeSelectMenuStyle(
  triggerRect: DOMRect,
  placement: EventqSelectMenuPlacement,
  gapPx = 4,
  widthMode: EventqSelectMenuWidth = 'trigger',
): EventqSelectMenuStyle {
  const width = widthMode === 'content' ? 'max-content' : `${triggerRect.width}px`;
  const alignEnd = placement === 'bottom-end' || placement === 'top-end';
  const left = alignEnd && widthMode === 'content' ? 'auto' : undefined;

  switch (placement) {
    case 'bottom-end':
      return {
        top: `${triggerRect.bottom + gapPx}px`,
        bottom: 'auto',
        left: left ?? `${triggerRect.right - triggerRect.width}px`,
        width,
      };
    case 'top-start':
      return {
        top: 'auto',
        bottom: `${window.innerHeight - triggerRect.top + gapPx}px`,
        left: `${triggerRect.left}px`,
        width,
      };
    case 'top-end':
      return {
        top: 'auto',
        bottom: `${window.innerHeight - triggerRect.top + gapPx}px`,
        left: left ?? `${triggerRect.right - triggerRect.width}px`,
        width,
      };
    case 'bottom-start':
    default:
      return {
        top: `${triggerRect.bottom + gapPx}px`,
        bottom: 'auto',
        left: `${triggerRect.left}px`,
        width,
      };
  }
}
